import {Row, Col, Table} from 'antd';
import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {
  INDEX_PAGE_SIZE_DEFAULT,
  INDEX_PAGE_SIZE_OPTIONS,
} from '../../../../../shared/constants/AppConst';
import {productTagServices} from '../../../../../shared/services/product-tag';
import {ProductTagProductsDto} from '../../../../../shared/services/product-tag/dtos/product-tag-products-dto';
import TableColumn from './columns';
import useTableV2 from '../../../../../shared/hooks/useTableV2';

interface IProductTagProductsProps {}

const ProductTagProducts = (props: IProductTagProductsProps) => {
  const [productsList, setProductsList] = useState<ProductTagProductsDto[]>([]);

  const [isTableLoading, setIsTableLoading] = useState(false);

  const {id} = useParams();

  const [pageSize, setPageSize] = useState<number>(INDEX_PAGE_SIZE_DEFAULT);

  const [pageSizeOptions] = useState<string[]>(INDEX_PAGE_SIZE_OPTIONS);

  const [currentPage, setCurrentPage] = useState(1);
  const {showTotal, ...tableV2} = useTableV2();

  useEffect(() => {
    if (id)
      (async () => {
        try {
          setIsTableLoading(true);
          let productList = await productTagServices.getProducts(id);
          setProductsList(productList.Data);
        } catch (error) {
          console.error(error);
        } finally {
          setIsTableLoading(false);
        }
      })();
  }, [id]);

  const pagination = {
    total: productsList?.length,
    pageSizeOptions: pageSizeOptions,
    pageSize: pageSize,
    showSizeChanger: true,
    showTotal,
    current: currentPage,
    onShowSizeChange: async (current: any, PageSize: any) => {
      setPageSize(PageSize);
    },
    onChange: async (page: any) => {
      setCurrentPage(page);
    },
  };

  return (
    <Row gutter={[0, 48]}>
      <Col span={24}>
        <Table
          columns={TableColumn()}
          dataSource={productsList}
          rowKey={(record: ProductTagProductsDto) => record.Id?.toString()}
          loading={isTableLoading}
          bordered={true}
          pagination={pagination}
          {...tableV2}
        />
      </Col>
    </Row>
  );
};

export default ProductTagProducts;
